import BaseAPI from './BaseAPI'

export default class LoginAPI extends BaseAPI {
    static login(data) {
        return this.execute('post', '/account/login', data)
    }

    static logout(data) {
        return this.execute('post', '/account/logout', data)
    }
}



// WEBPACK FOOTER //
// ./src/api/LoginAPI.js